/**
 * 트윗 유효성 검증 유틸리티
 */ export var validateTweetContent = function(content) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 280;
    if (!content.trim()) {
        return {
            isValid: false,
            error: 'Tweet content cannot be empty'
        };
    }
    if (content.length > maxLength) {
        return {
            isValid: false,
            error: "Tweet content cannot exceed ".concat(maxLength, " characters")
        };
    }
    return {
        isValid: true
    };
};
